export default "__VITE_ASSET__CsfeGOVb__"